module.exports = __webpack_public_path__ + "img/special.a47a9055.png";